function InitialSelection({ onSelectForm }) {
  const choices = [
    {
      id: "select-interview-btn",
      icon: "fa-microphone-alt",
      title: "Interview Request",
      description: "Draft a professional email to request an interview with a source for your article.",
      formType: "interview",
    },
    {
      id: "select-quote-check-btn",
      icon: "fa-check-double",
      title: "Quote Check",
      description: "Send quotes back to your source for accuracy confirmation before publishing.",
      formType: "quote-check",
    },
    {
      id: "select-graphics-btn",
      icon: "fa-image",
      title: "Graphics Generator",
      description: "Create polished Instagram graphics with custom headlines for story promotion.",
      formType: "graphics-generator",
    },
  ];

  return (
    <div id="initial-selection" className="initial-prompt">
      <h2>What would you like to do?</h2>
      <p className="subtitle">
        Choose a tool to get started with your story
      </p>

      <div className="choice-container">
        {choices.map((choice) => (
          <div key={choice.id} className="choice-option">
            <div
              className="choice-card"
              onClick={() => onSelectForm(choice.formType)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSelectForm(choice.formType);
                }
              }}
            >
              <div className="icon-circle">
                <i className={`fas ${choice.icon}`}></i>
              </div>
              <h3>{choice.title}</h3>
              <p>{choice.description}</p>
              <div className="arrow-hint">
                <i className="fas fa-arrow-right"></i> Get Started
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default InitialSelection;
